

export const navItems = [
  { label: '首页', view: 'home', path: '/' },
  { label: 'APP下载', view: 'download', path: '/download' },
  { label: '公司简介', view: 'about', path: '/about' },
  { label: '文化理念', view: 'culture', path: '/culture' }
]

export const homeSections = [
  {
    label: '理念',
    title: '重构人与数字世界的交互方式',
    text: '一个触点，可以连接万千场景；一次交互，可以激活沉睡价值；一个智能体，可以重塑企业增长。'
  },
  {
    label: '愿景',
    title: '让AI智能体进入真实经营场景',
    text: '以智能为桥梁，构建出一个人人可参与、企业可增长、成果可共享的共生系统。'
  },
  {
    label: '口号',
    title: '把每一次交互转化为可持续价值',
    text: '于方寸指尖的每一次交互之中，我们看见技术跨越鸿沟，看见价值回归共建者，看见每一个微小的参与终将汇聚为数字文明的浩荡长河。'
  }
]

export const visualGallery = [
  {
    title: '内容创作',
    label: 'Content Engine',
    image: '/images/pexels-content-timeline.jpg'
  },
  {
    title: '公域曝光',
    label: 'Public Traffic',
    image: '/images/pexels-growth-dashboard.jpg'
  },
  {
    title: '私域经营',
    label: 'Private CRM',
    image: '/images/pexels-private-ops-laptop.jpg'
  }
]

export const products = [
  {
    key: 'employee',
    eyebrow: 'AI Workforce',
    image: '/images/pexels-humanoid-robot.jpg'
  },
  {
    key: 'app',
    eyebrow: 'Consumer App',
    title: '点指之间 APP',
    subtitle: '让每一次交互都有价值回响，让每一个普通人都能公平享受数字文明带来的繁荣',
    image: '/images/pexels-mobile-app-night.jpg',
    desc:
      '点指之间是生态的用户入口。用户在内容消费、广告互动、游戏娱乐、签到与分享中的有效参与，将获得活跃积分，并通过 AI 驱动的动态转换机制沉淀为能量积分，用于生态消费与未来更多生活场景。',
    points: ['内容与互动', '游戏娱乐', '签到分享', '活跃积分', '能量积分', '生态消费'],
    metrics: [
      { value: '行为即价值', label: '参与机制' },
      { value: '活跃 → 能量', label: '持续流转' },
      { value: '持续流转', label: '生态权益' }
    ]
  }
]


export const mockOrder = {
  no: 'DZ202606170001',
  status: '待支付',
  payStatus: '未支付',
  auditStatus: '待支付后审核',
  deliveryStatus: '未交付',
  createdAt: '2026-06-17 10:28',
  consignee: '张先生',
  phone: '138 0000 0000',
  address: '浙江省杭州市西湖区文三路 88 号',
  serviceContact: '张先生',
  servicePhone: '138 0000 0000',
  company: '杭州某某科技有限公司',
  remark: '请在发货前联系确认软件服务开通时间。',
  timeline: [
    { title: '订单已创建', text: '官网创建 VitaeAI 数字员工订单草稿。', time: '2026-06-17 10:28' },
    { title: '等待支付', text: '支付完成后订单进入后台审核。', time: '待处理' },
    { title: '后台审核', text: '审核通过后安排实体发货与软件服务开通。', time: '待处理' },
    { title: '确认收货', text: '用户确认实体产品签收与软件服务开通。', time: '待处理' }
  ]
}

export const companyProfile = {
  title: '杭州维态人工智能科技有限公司',
  intro:
    // '维态科技是一家AI原生科技企业，总部位于杭州。公司以“重新定义人与数字世界的交互方式”为使命，拥有6项商标及7项软件著作权，2025年完成百万级天使轮融资。以点指之间APP与VitaeAI智能体数字员工系统为核心产品，致力于将AI能力转化为可交付、可生长的数字生产力。',
    // '杭州维态人工智能科技有限公司（Hangzhou Vitae AI Technology Co., Ltd.）是一家专注于人工智能技术创新与数字生态构建的科技企业。我们以AI智能体为核心，以人与数字世界的连接为入口，探索下一代智能交互方式，推动个人、企业与生态价值共同增长。',
    '杭州维态人工智能科技有限公司（Hangzhou Vitae AI Technology Co., Ltd.）是一家专注于人工智能创新与数字生态构建的科技企业。我们以“重新定义人与数字世界的交互方式”为使命，通过点指之间与 VitaeAI 两大产品，连接用户参与、企业增长与真实消费场景，让技术能力转化为可感知、可持续的生态价值。',
  tags: [' AI智能体', '数字生态', '价值共创', '企业增长'],
  facts: [
    { label: '定位', value: 'AI驱动的全场景数字生态共建者' },
    { label: '使命', value: '重新定义人与数字世界的交互方式' },
    { label: '产品布局', value: '点指之间APP/VitaeAI智能体数字员工' },
    { label: '生态价值', value: '用户参与、企业增长、价值共享' }
  ],
  visual: {
    image: '/images/pexels-ai-network-hand.jpg',
    title: '以 AI 连接用户参与、企业增长与价值共享的数字生态共建者。',
  }
}

export const cultureContent = {
  title: '于点指之间，见世间万千',
  lead:
    '以技术打破交互边界，让每一次参与都能连接更广阔的价值世界。',
  highlights: [
    { label: '01·愿景', text: '构建万物融合的数字生态',desc: "让数字价值真正服务于衣食住行、消费与生活，形成可持续的生态循环。" },
    { label: '02·使命', text: '重新定义人与数字世界的交互方式',desc: "让用户从流量贡献者成为价值创造者，让企业获得高效增长的新路径。" },
    { label: '03·理念', text: '打破交互边界，共启万物价值',desc: "以Al连接人、信息、服务与价值，让每位参与者都能找到自己的位置。" },
    { label: '04·口号', text: '于点指之间，见世间万千',desc: "于方寸指尖，连接一个充满可能的数字世界，见证参与创造的真实价值。" },
  ],
  mission:
    '我们相信，数字世界中的关系应当是双向的、价值化的、共创共享的。AI不只是效率工具，更应成为连接用户、企业与现实生活的普惠桥梁。',
  closing:
    '点指之间与VitaeAI，以技术赋能、价值共享与生态共建，推动更加公平、智能、繁荣的数字未来。',
  visual: {
    image: '/images/pexels-ai-brain.jpg',
    title: '让每一次点指，都成为生态共建的力量',
  }
}
